var _path, _path2, _path3, _circle, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMessageChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.786 2.295v8.25l2.063.516.515 3.094 3.094-3.094 6.703-.516V2.81l-1.547-1.03H2.817l-1.03.515z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.65c0-.84 0-1.26-.163-1.581a1.5 1.5 0 00-.656-.656c-.32-.163-.74-.163-1.581-.163H9.9c-.84 0-1.26 0-1.581.163a1.5 1.5 0 00-.656.656c-.163.32-.163.74-.163 1.581v1.886c0 .84 0 1.26.163 1.58a1.5 1.5 0 00.656.656c.32.164.74.164 1.581.164h1.348c.28 0 .419 0 .554.025.12.022.236.058.347.108.125.057.24.137.469.296L14.25 16.5v-1.564c.699 0 1.048 0 1.324-.114a1.5 1.5 0 00.812-.812c.114-.276.114-.625.114-1.324V10.65z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.25l-2.306 2.335c-.322.326-.483.489-.621.5a.375.375 0 01-.316-.13c-.09-.105-.09-.334-.09-.791v-1.17c0-.411-.337-.708-.743-.768v0a2.25 2.25 0 01-1.9-1.9C1.5 9.164 1.5 8.97 1.5 8.583V5.1c0-1.26 0-1.89.245-2.371a2.25 2.25 0 01.984-.984C3.209 1.5 3.839 1.5 5.1 1.5h5.55c1.26 0 1.89 0 2.371.245.424.216.768.56.984.984.245.48.245 1.11.245 2.371v3.15m0 8.25l-1.632-1.135c-.23-.16-.345-.24-.47-.296a1.497 1.497 0 00-.346-.108c-.135-.025-.275-.025-.554-.025H9.9c-.84 0-1.26 0-1.581-.164a1.5 1.5 0 01-.656-.655c-.163-.321-.163-.741-.163-1.581V10.65c0-.84 0-1.26.163-1.581a1.5 1.5 0 01.656-.656c.32-.163.74-.163 1.581-.163h4.2c.84 0 1.26 0 1.581.163a1.5 1.5 0 01.656.656c.163.32.163.74.163 1.581v2.036c0 .699 0 1.048-.114 1.324a1.5 1.5 0 01-.812.812c-.276.114-.625.114-1.324.114V16.5z",
    stroke: "#111112",
    strokeOpacity: 0.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.004,
    cy: 11.576,
    r: 0.516,
    fill: "#111112",
    fillOpacity: 0.8
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.066,
    cy: 11.576,
    r: 0.516,
    fill: "#111112",
    fillOpacity: 0.8
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.129,
    cy: 11.576,
    r: 0.516,
    fill: "#111112",
    fillOpacity: 0.8
  })));
}
export default SvgMessageChat;